/*
 * @Author: Musa Tabitay
 * @Date: 2020-04-05 23:24:28
 * @LastEditTime: 2022-05-02 15:33:05
 */

// 查看菜单列表
const menus = [
  //   // {
  //   //   name: 'قىسقا ماقالا',
  //   //   path: '/short_video',
  //   //   icon: 'el-icon-video-camera'
  //   // }
  //   ]
  // },

  {
    name: 'تەكشەلەر',
    path: '/wechatconfig',
    icon: 'el-icon-s-tools'
  },

  // {
  //   name: 'ۇيرەنۋ',
  //   path: '/guide',
  //   icon: 'el-icon-s-opportunity'
  // },
  // {
  //   name: 'ەسكەرتۋ',
  //   path: '/agree',
  //   icon: 'el-icon-postcard'
  // }

  {
    name: 'باسقارۋ',
    path: 'course',
    icon: 'el-icon-s-finance',
    children: [
      {
        name: 'باننەر',
        path: '/swiper',
        icon: 'el-icon-s-finance'
      },
      // {
      //   name: 'اۆتور',
      //   path: '/teacherList',
      //   icon: 'el-icon-s-opportunity'
      // },
      // {
      //   name: 'ارناۋلى ايدارشا',
      //   path: '/topic',
      //   icon: 'el-icon-s-shop'
      // },
      {
        name: 'كينو ءتۇرى',
        path: '/category',
        icon: 'el-icon-s-grid'
      },
      {
        name: 'كينو',
        path: '/course',
        icon: 'el-icon-edit-outline'
      }
    ]
  },
  {
    name: 'ەسەپ',
    path: 'member',
    icon: 'el-icon-s-finance',
    children: [{
      name: 'VIP ءتۇرى',
      path: '/member',
      icon: 'el-icon-s-goods'
    },
    {
      name: 'VIP مۇشە',
      path: '/vip',
      icon: 'el-icon-user'
    },
    {
      name: 'جەكە كىرىس',
      path: '/order',
      icon: 'el-icon-price-tag'
    },
    {
      name: 'مۇشەلەر',
      path: '/users',
      icon: 'el-icon-s-custom'
    },
    {
      name: 'قولداۋ',
      path: '/appreciates',
      icon: 'el-icon-user'
    }
    ]
  }
  // {
  //   name: 'wxv ايدىن الۋ',
  //   path: '/wxv',
  //   icon: 'el-icon-user'
  // }
]

export {
  menus
}



// WEBPACK FOOTER //
// ./src/views/menus.js